import { Box, Button, Divider, Flex, Radio, Text } from '@chakra-ui/react';

import { Input, Label } from '../../../components/formComponents';

type SuggestedAddress = {
  address_line: string;
  address_line_2?: string;
  city: string;
  state: string;
  zip: string;
  county?: string | null;
};

type SuggestedAddressCardProps = {
  suggestedAddress: SuggestedAddress;
  onManualEntry: () => void;
};

const SuggestedAddressCard = ({ suggestedAddress, onManualEntry }: SuggestedAddressCardProps) => {
  return (
    <>
      <Label>IS THIS YOUR CURRENT ADDRESS?</Label>
      <Flex
        p={2}
        border="2px solid"
        borderColor="leaseEndBlue"
        rounded="md"
        bg="gray.100"
        alignItems="center"
        gap={2}
      >
        <Radio isChecked size="lg" px={2} />
        <Box flex={1}>
          <Text fontSize="lg" fontWeight="500" color="leaseEndBlue">
            {`${suggestedAddress.address_line}${
              suggestedAddress.address_line_2 ? `, ${suggestedAddress.address_line_2}` : ''
            }`}
          </Text>
          <Text fontSize="md" color="gray.500" mt={1}>
            {suggestedAddress.city}, {suggestedAddress.state} {suggestedAddress.zip}
          </Text>
        </Box>
      </Flex>
      {!suggestedAddress.county && (
        <Box mt={5}>
          <Label>COUNTY</Label>
          <Input name="county" placeholder="County" />
        </Box>
      )}
      <Box mt={8}>
        <Button
          variant="link"
          fontSize="lg"
          textDecoration="underline"
          textUnderlineOffset={2}
          onClick={onManualEntry}
        >
          No, enter address manually
        </Button>
      </Box>
      <Divider mt={8} mb={8} />
    </>
  );
};

export default SuggestedAddressCard;
